import React, {Component} from 'react';
import { Card, CardHeader, CardText } from "material-ui/Card";
import Avatar from "material-ui/Avatar";
import { isEqual } from "lodash";
import Media from "react-media";
import { FieldArray } from 'redux-form';
import {
  IconVariant
} from "../../components/mui/icon";
import {
  FullForm
} from "../styled";

import {
  renderVariantList,
  renderVariantListSmall,
  VariantsDialog
} from "../edit";
import { getVariants } from "../utils";

class  FormVariants extends Component{
  constructor(props) {
    super(props);
    this.state = {
      expandedVariant: true,
      oldVariant: props.variant,
      isGetVariant: false
    };
    //  console.log(JSON.stringify(props.record));
    
  }
  handleExpandVariantChange = expanded => {
    this.setState({ expandedVariant: expanded });
  };
   
  componentWillReceiveProps(nextProps) {
    
    if (nextProps.variant && !this.state.isGetVariant) {
      this.setState({
        oldVariant: nextProps.variant,
        isGetVariant: true
      });
    }
  }
  onCancelOptions = items => {
    if (this.state.oldVariant !== undefined) {
      this.props.variant["options"] = this.state.oldVariant["options"];
    }
  };
  onSaveOptions = () => {
    let value = [];
    let count = 0;
    // const newValues = getVariants(
    //   this.props.variant.options,
    //   this.props.priceProduct,
    //   this.props.nameProduct
    // );
    const newValues = getVariants(
      this.props.variant.options,
      this.props.priceProduct,
      this.props.brandProduct,
      this.props.slugProduct
    );
    this.props.variant.options.map((item, index) => {
      const contentValues = item.values.filter(
        f => !this.state.oldVariant.options[index].values.includes(f)
      );
      if (contentValues.length > 0) {
        contentValues.map(item => {
          value[count] = item;
          count++;
          return null;
        });
      }
      return null;
    });
    let newVariant = [];
    let count1 = 0;
    value.map((item, index1) => {
      const nextValue = newValues.filter(f => {
        const name = f.name;
        return name.includes(item);
      });
      if (nextValue.length > 0) {
        nextValue.map(item => {
          newVariant[count1] = item;
          count1++;
          return null;
        });
      }
      return null;
    });
    if (newVariant.length > 0) {
      newVariant.map(item => {
        const contentVariants = this.props.variant.variants.filter(f => {
          const itemName = item.name;
          const fieldName = f.name;
          return isEqual(itemName.toLowerCase(), fieldName.toLowerCase());
        });
        if (contentVariants.length === 0) {
          this.props.variant.variants.push(item);
        }
        return null;
      });
      this.setState({
        oldVariant: this.props.variant
      });
    }
  };
  renderVariants = (children, record, resource, basePath, translate) => {
    return (
      <Card
        expanded={this.state.expandedVariant}
        onExpandChange={this.handleExpandVariantChange}
        style={{ marginBottom: 16 }}
      >
        <CardHeader
          title="Variants"
          subtitle=""
          avatar={<Avatar icon={<IconVariant />} />}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText expandable={true}>
          <div>
            <VariantsDialog
              {...this.props}
              dataOptions={this.state.oldVariant}
              onSave={value => this.onSaveOptions(value)}
              onCancel={items => this.onCancelOptions(items)}
            />
            <Media query="(max-width: 768px)">
              {matches =>
                matches ? (
                  <FieldArray
                    name="variant.variants"
                    component={renderVariantListSmall}
                    props={{ translate: translate }}
                  />
                ) : (
                  <FieldArray
                    name="variant.variants"
                    props={{ translate: translate }}
                    component={renderVariantList}
                  />
                )
              }
            </Media>
          </div>
        </CardText>
      </Card>
    );
  };
   

  render(){
    const {
      children,
      record,
      resource,
      basePath,
      translate
    } = this.props;
    return(
      <div>
        <FullForm style={{marginTop: 16}}>
        {this.renderVariants(
          children.props.children,
          record,
          resource,
          basePath,
          translate
        )}
      </FullForm>
      </div>
    );
  }
}
//
export default FormVariants;


// WEBPACK FOOTER //
// ./src/products/form/FormVariants.js